import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]

  // The counter's two colours come from the markup so both brands can drive this
  // file. A class named only in here is outside every Tailwind content glob, so
  // Workays' bundle would never compile the Yseasonal defaults.
  static classes = ['warning', 'neutral']

  static DEFAULT_CLASSES = {
    warning: ['text-red-500'],
    neutral: ['text-gray-500']
  }

  classesFor(name) {
    const capitalised = name.charAt(0).toUpperCase() + name.slice(1)
    if (this[`has${capitalised}Class`]) return this[`${name}Classes`]

    return this.constructor.DEFAULT_CLASSES[name]
  }

  connect() {
    this.update = this.update.bind(this)
    this.autoGrow = this.autoGrow.bind(this);
    this.update()
    this.autoGrow()
    this.inputTarget.addEventListener("input", this.update)
    this.inputTarget.addEventListener("input", this.autoGrow)
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.update)
  }

  update() {
    const currentLength = this.characterCount;
    const maxLength = this.maxLength;
    const minLength = this.minLength;
    let displayText;
    let warning;

    if (minLength > 0 && currentLength < minLength) {
      displayText = `-${minLength - currentLength}`;
      warning = true;
    } else if (maxLength > 0 && currentLength > maxLength) {
      displayText = `+${currentLength - maxLength}`;
      warning = true;
    } else {
      displayText = `${currentLength}`;
      warning = false;
    }

    this.counterTarget.textContent = displayText;
    this.updateColorClass(warning);
  }

  updateColorClass(warning) {
    const on = this.classesFor(warning ? 'warning' : 'neutral');
    const off = this.classesFor(warning ? 'neutral' : 'warning');

    this.counterTarget.classList.remove(...off);
    this.counterTarget.classList.add(...on);
  }

  autoGrow() {
    this.inputTarget.style.height = 'auto';
    this.inputTarget.style.height = this.inputTarget.scrollHeight + 'px';
  }

  get characterCount() {
    return this.inputTarget.value.length
  }

  get maxLength() {
    return this.inputTarget.maxLength || 0
  }

  get minLength() {
    return this.inputTarget.minLength || 0
  }
}
